import PassengersContainer from './PassengersContainer';

export default PassengersContainer;
